import { atom } from 'recoil';
import { IDsMetrics } from '.';

const dsMetrics: IDsMetrics = {
  clientId: '',
  createdAt: '',
  datasourceId: '',
  id: '',
  metrics: [],
  updatedAt: '',
  channel: '',
};
const isSelectModal = false;

export const SocialDatasourceMetricState = atom<IDsMetrics>({
  key: 'social-datasource-metrics',
  default: dsMetrics,
});

export const AdsDatasourceMetricState = atom<IDsMetrics>({
  key: 'ads-datasource-metrics',
  default: dsMetrics,
});

export const EmailDatasourceMetricState = atom<IDsMetrics>({
  key: 'email-datasource-metrics',
  default: dsMetrics,
});

export const WebDatasourceMetricState = atom<IDsMetrics>({
  key: 'web-datasource-metrics',
  default: dsMetrics,
});

export const isSelectMetricModalState = atom<boolean>({
  key: 'is-select-metrics-modal',
  default: isSelectModal,
});
